import axios from "axios";

const api = axios.create({
  baseURL: "https://your-api-url.com/api",
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    try {
      // Get token saved after successful login
      const token = sessionStorage.getItem("token");

      // Do not attach token to Login API
      const isLoginRequest = config.url?.includes(
        "/CustomerMaster/Login"
      );

      if (token && !isLoginRequest) {
        config.headers = config.headers || {};

        // Always use latest logged-in user's token
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch (error) {
      console.error(
        "Error getting authentication token:",
        error
      );
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      console.warn(
        "Unauthorized request - token may be expired."
      );
    }

    return Promise.reject(error);
  }
);

export default api;